export enum CompetitionMatchEventEventTypes {
  GOAL = 'Goal',
  PENALTY = 'Penalty',
  TEAM_ABSENT = 'Team absent'
}

export class CompetitionMatchEvent {
  id: number
  competitionMatchId: number
  competitionTeamId: number
  timeInMatch: number
  eventType: CompetitionMatchEventEventTypes
  amount: number
  competitionPlayerId1: number
  competitionPlayerId2: number
  memo: string
}
